export const Section = ({
  children,
  id = '',
}: {
  children: React.ReactNode
  id?: string
}) => (
  <section className='container' id={id}>
    <div className='mc-py-4'>{children}</div>
  </section>
)
